import { NO_PAGINATION } from '@/configuration/clientTableConf';
import {
  TIERS_TYPE_CLIENT, TIERS_SOUS_TYPE_AUCUN,
} from '@/configuration/tiers/tiersConf';
import genererdemandeImpression from '@/services/import/demandeImpression/genererDemandeImpression';
import { create as createdemandeImpression } from '@/api/logistique/demandeImpression/index';
import { columns } from '@/services/import/demandeImpression/templateDemandeImpression';
import i18n from '@/i18n/index';
import store from '@/store/store';
import { getAll as getAllTiers } from '@/api/tiers/index';
import { getAll as getAllCampagnes } from '@/api/campagne/index';
import { getAll as getAllDispositifs } from '@/api/gabed/dispositif/index';
import { getAll as getAllEmplacements } from '@/api/gabed/emplacement/index';

export function ErrorDemandeImpressionTranslate(errors) {
  if (!errors || !Array.isArray(errors)) return [];
  return errors.map(error => {
    if (error.endsWith('_IS_REQUIRED')) {
      return i18n.t('importationDemandeImpression.errors.requiredPropertie', { label: error.split('_')[0] });
    }
    if (error.includes('_MAX_LENGTH_')) {
      return i18n.t('importationDemandeImpression.errors.maxLengthPropertie', { label: error.split('_')[0], length: error.split('_')[error.split('_').length - 1] });
    }
    if (error.includes('_CLIENT_NOT_FOUND')) {
      return i18n.t('importationDemandeImpression.errors.clientNotFound', { name: error.split('_')[0] });
    }
    if (error.includes('_DISPOSITIF_NOT_FOUND')) {
      return i18n.t('importationDemandeImpression.errors.dispositifNotFound', { name: error.split('_')[0] });
    }
    if (error.includes('_CAMPAGNE_NOT_FOUND')) {
      return i18n.t('importationDemandeImpression.errors.campagneNotFound', { name: error.split('_')[0] });
    }
    if (error.includes('_CLIENT_DO_NOT_MATCH')) {
      return i18n.t('importationDemandeImpression.errors.clientDoNotMach', { name: error.split('_')[0] });
    }
    switch (error) {
      default:
        return 'Un problème est survenu';
    }
  }).join(' - ');
}

function validationLigne(ligne, clients, campagnes, dispositifs) {
  const error = {
    numLigne: ligne.numLigne,
    errors: [],
  };

  const campagne = campagnes.find(c => c.libelle.toLowerCase()
    === ligne.libelleCampagne.toLowerCase());
  if (ligne.libelleCampagne && !campagne) {
    error.errors.push(`${ligne.libelleCampagne}_CAMPAGNE_NOT_FOUND`);
  }

  const client = clients.find(c => c.referenceExterne === ligne.refExterneTiers);
  if (ligne.refExterneTiers && !client) error.errors.push(`${ligne.refExterneTiers}_CLIENT_NOT_FOUND`);

  const dispositif = dispositifs.find(d => d.code === ligne.codeDispositif
    && client != null && client.id === d.emplacement.clientId);
  if (ligne.codeDispositif && !dispositif) error.errors.push(`${ligne.codeDispositif}_DISPOSITIF_NOT_FOUND`);

  if (client != null && dispositif && client.id !== dispositif.emplacement.clientId) {
    error.errors.push(`${ligne.refExterneTiers}_CLIENT_DO_NOT_MATCH`);
  }
  columns.forEach(column => {
    const columnErrors = column.checkValue(ligne[column.key]);
    if (columnErrors.length > 0) error.errors = error.errors.concat(columnErrors);
  });

  if (error.errors.length > 0) throw error;
}

export async function makeDemandeImpressionGenerated(file) {
  const lignes = file[0];
  const demandeImpressions = [];
  const errors = [];

  const campagnesExistant = (await getAllCampagnes({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      type: TIERS_TYPE_CLIENT,
      sousType: [TIERS_SOUS_TYPE_AUCUN],
    },
    limit: NO_PAGINATION,
  })).data.result.items;
  const clientsExistant = (await getAllTiers({
    query: {
      societeId: store.getters['societe/societeActiveId'],
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  const dispositifsExistant = (await getAllDispositifs({
    query: {
      societeId: store.getters['societe/societeActiveId'],
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  // eslint-disable-next-line no-unused-vars
  const emplacementExistant = (await getAllEmplacements({
    query: {
      societeId: store.getters['societe/societeActiveId'],
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  for (let i = 1; i < dispositifsExistant.length; i += 1) {
    const monDispositif = dispositifsExistant[i];
    const monEmplacement = emplacementExistant.find(e => e.id === monDispositif.emplacementId);
    if (monEmplacement != null && monEmplacement.client != null) {
      monDispositif.emplacement.client = monEmplacement.client;
    }
  }

  // saut de la premiere vu qu'on a 2 lignes d'entete
  for (let i = 1; i < lignes.length; i += 1) {
    try {
      validationLigne(lignes[i], clientsExistant, campagnesExistant, dispositifsExistant);
    } catch (e) {
      errors.push(e);
    }
  }
  if (errors.length > 0) {
    errors.unshift({ total: lignes.length - 1, totalErrors: errors.length });
    throw errors;
  }

  // saut de la premiere vu qu'on 2 lignes d'entete
  for (let i = 1; i < lignes.length; i += 1) {
    const demandeImpression = genererdemandeImpression(lignes[i], clientsExistant,
      campagnesExistant, dispositifsExistant);
    demandeImpressions.push(demandeImpression);
  }

  return demandeImpressions;
}

export async function makeDemandeImpressionImport(demandeImpressions) {
  const errors = [];
  for (let i = 0; i < demandeImpressions.length; i += 1) {
    try {
      const demandeImpressionToCreate = demandeImpressions[i];
      // eslint-disable-next-line no-await-in-loop
      await createdemandeImpression(demandeImpressionToCreate);
    } catch (e) {
      errors.push({ error: e });
    }
  }
  if (errors.length > 0) throw errors;
}
